module.exports = __webpack_public_path__ + "f8831af6efd497a49974d732e04d4b04.png";